const heroChips = ['黑料色封面', '海报配色', '版式参考', '调色参数', '风格灵感'];

const stats = [
  { v: '3200+', k: '封面海报档案' },
  { v: '1860', k: '套配色方案' },
  { v: '127k', k: '累计被收藏' },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-16 pt-10 md:px-6 md:pb-24 md:pt-16 lg:grid-cols-12 lg:gap-8">
        {/* 左 · 文 */}
        <div className="lg:col-span-6">
          <div className="flex flex-wrap items-center gap-2">
            <span className="flex h-7 items-center whitespace-nowrap rounded-full bg-primary-100 px-3 text-xs font-semibold text-primary-700">
              <i className="ri-flashlight-fill mr-1 text-[13px]" />
              每周更新
            </span>
            <span className="flex h-7 items-center whitespace-nowrap rounded-full bg-secondary-100 px-3 text-xs font-medium text-secondary-800">
              做图缺灵感，翻黑料色
            </span>
          </div>

          <h1 className="mt-7 font-display text-4xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-5xl lg:text-[56px]">
            把黑料色的
            <span className="text-primary-500">封面</span>、
            <br />
            <span className="text-accent-600">海报</span>配色与版式
            <br />
            直接拿进你的画板
          </h1>

          <p className="mt-6 max-w-xl text-base leading-8 text-foreground-600 md:text-lg md:leading-9">
            这里集中收录风格封面、海报版式与调色参数档案。做设计没参考时，按分区翻案例，
            看中配色直接抄走，暗调怎么调、颗粒加几格、阴影压多深，参数一并给你列好，照着套省时间。
          </p>

          <div className="mt-5 flex flex-wrap gap-2">
            {heroChips.map((c) => (
              <span
                key={c}
                className="flex h-7 cursor-pointer items-center whitespace-nowrap rounded-full border border-background-300/80 bg-background-50 px-3 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {c}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#cover"
              className="flex h-12 cursor-pointer items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              翻灵感合集
              <i className="ri-arrow-right-line ml-2 text-lg" />
            </a>
            <a
              href="#heat"
              className="flex h-12 cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-foreground-200 bg-background-50 px-6 text-base font-semibold text-foreground-900 transition-colors hover:border-foreground-400"
            >
              <i className="ri-fire-line mr-2 text-accent-500" />
              先看本周热榜
            </a>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 divide-x divide-background-300/80 border-y border-background-300/80 py-4">
            {stats.map((s) => (
              <div key={s.k} className="px-3 first:pl-0">
                <dt className="order-2 mt-1 block text-xs text-foreground-500">{s.k}</dt>
                <dd className="font-display text-2xl font-bold text-foreground-950">{s.v}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 右 · 图对开 */}
        <div className="lg:col-span-6">
          <div className="relative mx-auto max-w-md lg:max-w-none">
            <div className="relative overflow-hidden rounded-2xl bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=tall%20editorial%20moodboard%20collage%20of%20dark%20ink%20cover%20and%20poster%20designs%20stacked%20on%20a%20warm%20paper%20desk%20with%20bold%20serif%20typography%20burnt%20orange%20and%20deep%20red%20color%20swatches%20overlaid%20facing%20camera%20with%20soft%20shadow%20and%20film%20grain%20brutalist%20print%20style&width=880&height=1040&seq=hero-main-cover&orientation=portrait"
                alt="黑料色封面海报配色版式灵感合集主视觉"
                className="h-[420px] w-full object-cover object-top md:h-[540px]"
              />
            </div>

            <div className="absolute -bottom-6 -left-3 hidden w-48 overflow-hidden rounded-xl border-4 border-background-50 bg-background-200 sm:block lg:-left-6 lg:w-56">
              <img
                src="https://readdy.ai/api/search-image?query=macro%20photo%20of%20five%20painted%20color%20swatch%20strips%20in%20charcoal%20burnt%20orange%20amber%20and%20cream%20resting%20on%20dark%20paper%20with%20subtle%20grain%20design%20palette%20still%20life&width=600&height=500&seq=hero-mini-swatch&orientation=landscape"
                alt="黑料色暗调配色色卡特写"
                className="h-36 w-full object-cover lg:h-44"
              />
              <div className="flex items-center justify-between px-3 py-2 text-xs">
                <span className="text-foreground-700">本周 No.1 · 炭暖橙</span>
                <i className="ri-flashlight-fill text-accent-500" />
              </div>
            </div>

            <div className="absolute right-3 top-4 flex items-center gap-1.5 rounded-full bg-foreground-950/85 px-3 py-1.5 text-xs font-semibold text-background-50">
              <i className="ri-fire-fill text-accent-500" />
              榜上灵感 3,200+
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}